/* Looma — bundles natifs (2026-10-19 ; mise en page « mg » façon Migril pour am, 2026-10-20). Actif seulement si window.LMO_NATIVE et si la fiche contient un .lmb (snippets/lmo-bundle.liquid).
   Paliers, prix, sélecteurs de variante par unité (Postpartum), cadeaux, ajout au panier avec les codes Shopify du palier. */
(function () {
  if (!window.LMO_NATIVE) return;

  /* Données des paliers = copie des bundles MoonBundle du 2026-10-19 (voir cart-natif/README.md). t = palier 1-based. */
  var PRESETS = {
    balm: {
      defaultTier: 2,
      tiers: [
        { qty: 1, title: '1 Jar', sub: 'Standard Price', codes: [] },
        { qty: 3, title: 'Buy 2, Get 1 FREE', pct: 33.33, sub: '', label: 'SAVE {pct}', sticker: 'MOST POPULAR', codes: ['BALM3'] },
        { qty: 5, title: 'Buy 3, Get 2 FREE', pct: 40, sub: '', label: 'SAVE {savings}', sticker: 'BEST VALUE', codes: ['BALM5'] }
      ],
      giftCodes: { BALMGUIDE: [2, 3], BALMPATCH: [3] },
      themePriceSync: true
    },
    oil: {
      defaultTier: 2,
      baseUnit: 3900,
      tiers: [
        { qty: 1, title: '1 Bottle', sub: '1-month supply', codes: [] },
        { qty: 2, title: '2 Bottles', total: 5900, sub: '2-month supply · Free shipping', label: 'SAVE {pct}', sticker: 'MOST POPULAR', codes: ['OIL2'] },
        { qty: 3, title: '3 Bottles', total: 7800, sub: '3-month supply · Free shipping', label: 'SAVE {savings}', sticker: 'BEST VALUE', codes: ['OIL3'] }
      ],
      giftCodes: {}
    },
    am: {
      defaultTier: 2,
      baseUnit: 3999,
      noPic: true,
      tiers: [
        { qty: 1, title: 'Buy 1 Bottle', sub: '1 month supply', codes: [] },
        { qty: 3, title: 'Buy 2, Get 1 FREE', total: 7998, sub: '3 month supply', label: 'SAVE {pct}', sticker: 'MOST POPULAR', codes: ['AMB3'] },
        { qty: 5, title: 'Buy 3, Get 2 FREE', total: 11997, sub: '5 month supply', label: 'SAVE {pct}', sticker: 'BEST VALUE', codes: ['AMB5'] }
      ],
      giftCodes: { AMBOOK: [2, 3], AMROLL: [3] }  /* 2026-10-25 : 3 paliers, Kitchen e-book + livraison (2-3), roll-on (3) ; demande d'Eliès */
    },
    ppb: {
      defaultTier: 2,
      baseUnit: 3990,
      perUnitVariants: true,
      tiers: [
        { qty: 2, title: 'Buy 1, Get 1 FREE', total: 3990, sub: '2 briefs · {each} each', label: 'SAVE {pct}', codes: ['PPB2'] },
        { qty: 4, title: 'Buy 2, Get 2 FREE', total: 4990, sub: '4 briefs · {each} each · Free shipping', label: 'SAVE {pct}', sticker: 'MOST POPULAR', codes: ['PPB4'] },
        { qty: 6, title: 'Buy 3, Get 3 FREE', total: 6490, sub: '6 briefs · {each} each · Free shipping', label: 'SAVE {pct}', sticker: 'BEST VALUE', codes: ['PPB6'] }
      ],
      giftCodes: { PPBBOOK: [1, 2, 3] }
    }
  };

  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
  var fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }); } catch (e) { fmt = null; }
  function money(c) { return fmt ? fmt.format(c / 100) : (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function init(box) {
    if (box.__lmb) return; box.__lmb = true;
    var key = box.getAttribute('data-lmb'), P = PRESETS[key];
    var cfgEl = box.querySelector('[data-lmb-config]');
    if (!P || !cfgEl) return;
    var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    document.documentElement.classList.add('lmb-on');
    var sel = P.defaultTier, units = [];
    var tiersEl = box.querySelector('[data-lmb-tiers]');

    function calc(t) {
      var full = C.compare * t.qty;               /* prix barré : quantité × prix barré du produit */
      var total = t.total != null ? Math.round(t.total * C.unit / P.baseUnit)   /* total cible en USD, mis à l'échelle de la devise affichée */
        : (t.pct ? Math.round(C.unit * t.qty * (1 - t.pct / 100)) : C.unit * t.qty);
      return { full: full, total: total, savings: full - total, pct: full ? Math.round((full - total) / full * 100) : 0, each: Math.round(total / t.qty) };
    }
    function text(s, c) { return (s || '').replace('{pct}', c.pct + '%').replace('{savings}', money(c.savings)).replace('{each}', money(c.each)).replace('{full}', money(c.full)); }

    function variantSelects(i) {
      var u = units[i], o = C.options, h = '<div class="lmb__unit"><span class="lmb__unit-n">#' + (i + 1) + '</span>';
      o.forEach(function (op, k) {
        h += '<label class="lmb__sel"><span>' + esc(op.name) + '</span><select data-unit="' + i + '" data-opt="' + k + '">';
        op.values.forEach(function (v) { h += '<option value="' + esc(v) + '"' + (u[k] === v ? ' selected' : '') + '>' + esc(v) + '</option>'; });
        h += '</select></label>';
      });
      return h + '</div>';
    }
    function renderMg() {
      var h = '', chk = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      P.tiers.forEach(function (t, i) {
        var n = i + 1, c = calc(t), on = n === sel, img = (C.imgs && C.imgs[t.img - 1]) || C.image;
        h += '<label class="lmg__card' + (on ? ' is-on' : '') + '" data-tier="' + n + '">' +
          (t.sticker ? '<span class="lmg__badge' + (t.sticker2 ? ' lmg__badge--b' : '') + '">' + esc(t.sticker) + '</span>' : '') +
          '<input type="radio" name="lmb-' + key + '" value="' + n + '"' + (on ? ' checked' : '') + '>' +
          '<span class="lmg__row"><span class="lmg__pic"><img src="' + esc(img) + '" alt="" width="80" height="80" loading="lazy"></span>' +
          '<span class="lmg__txt"><strong class="lmg__title">' + esc(t.title) + '</strong><span class="lmg__sub">' + esc(text(t.sub, c)) + '</span></span>' +
          '<span class="lmg__px"><strong>' + money(c.total) + '</strong>' + (c.full > c.total ? '<s>' + money(c.full) + '</s>' : '') + '</span></span>' +
          (on && t.perks.length ? '<span class="lmg__perks">' + t.perks.map(function (p) {
            return '<span class="lmg__perk">' + chk + '<span><b>' + esc(text(p[0], c)) + '</b><em>' + esc(text(p[1], c)) + '</em></span></span>';
          }).join('') + '</span>' : '') +
          '</label>';
      });
      tiersEl.innerHTML = h;
      box.querySelectorAll('[data-lmb-gift]').forEach(function (g) {
        var tiers = (g.getAttribute('data-tiers') || '').split(' ');
        g.classList.toggle('is-locked', tiers.indexOf(String(sel)) < 0);
      });
      var c = calc(P.tiers[sel - 1]);
      document.dispatchEvent(new CustomEvent('lmb:change', { detail: { preset: key, tier: sel, total: c.total, full: c.full, totalText: money(c.total), fullText: money(c.full) } }));
    }
    function render() {
      if (P.layout === 'mg') return renderMg();
      var h = '';
      P.tiers.forEach(function (t, i) {
        var n = i + 1, c = calc(t), on = n === sel;
        h += '<label class="lmb__tier' + (on ? ' is-on' : '') + '" data-tier="' + n + '">' +
          (t.sticker ? '<span class="lmb__sticker">' + esc(t.sticker) + '</span>' : '') +
          '<input type="radio" name="lmb-' + key + '" value="' + n + '"' + (on ? ' checked' : '') + '>' +
          '<span class="lmb__radio"></span>' +
          (P.noPic ? '' : '<span class="lmb__pic"><img src="' + esc(C.image) + '" alt="" width="52" height="52"><span class="lmb__qty">x' + t.qty + '</span></span>') +
          '<span class="lmb__txt"><strong class="lmb__title">' + esc(t.title) + '</strong>' +
          (t.label ? ' <span class="lmb__pill">' + esc(text(t.label, c)) + '</span>' : '') +
          (t.sub ? '<em class="lmb__sub">' + esc(text(t.sub, c)) + '</em>' : '') + '</span>' +
          '<span class="lmb__px"><strong class="lmb__now">' + money(c.total) + '</strong>' + (c.full > c.total ? '<s class="lmb__was">' + money(c.full) + '</s>' : '') + '</span>' +
          (on && P.perUnitVariants ? '<span class="lmb__units">' + units.slice(0, t.qty).map(function (_, k) { return variantSelects(k); }).join('') + '</span>' : '') +
          '</label>';
      });
      tiersEl.innerHTML = h;
      box.querySelectorAll('[data-lmb-gift]').forEach(function (g) {
        var tiers = (g.getAttribute('data-tiers') || '').split(' ');
        g.classList.toggle('is-locked', tiers.indexOf(String(sel)) < 0);
      });
      syncThemePrice();
      var c = calc(P.tiers[sel - 1]);
      document.dispatchEvent(new CustomEvent('lmb:change', { detail: { preset: key, tier: sel, total: c.total, full: c.full, totalText: money(c.total), fullText: money(c.full) } }));
    }
    function syncThemePrice() {
      if (!P.themePriceSync) return;
      var b = document.querySelector('.lmbp'); if (!b) return;
      var c = calc(P.tiers[sel - 1]);
      var n = b.querySelector('.lmbp__now'), w = b.querySelector('.lmbp__was'), s = b.querySelector('.lmbp__save');
      if (n) n.textContent = money(c.total);
      if (w) w.textContent = money(c.full);
      if (s && s.lastChild && s.lastChild.nodeType === 3) s.lastChild.textContent = 'Save ' + c.pct + '%';
    }
    function firstUnit() { return C.options.map(function (o) { return o.values[0]; }); }
    for (var i = 0; i < 6; i++) units.push(firstUnit());

    box.addEventListener('change', function (e) {
      var r = e.target;
      if (r.matches && r.matches('input[type=radio]')) { sel = parseInt(r.value, 10); render(); return; }
      if (r.matches && r.matches('select[data-unit]')) { units[+r.getAttribute('data-unit')][+r.getAttribute('data-opt')] = r.value; }
    });
    render();

    /* pop-up d'upsell (preset avec P.upsell) : au palier P.upsell.tier, propose le produit de [data-lmb-upsell] avec son code. */
    box.__lmbUpsell = function () {
      var dlg = document.querySelector('[data-lmb-upsell="' + key + '"]');
      if (!P.upsell || sel !== P.upsell.tier || !dlg || !dlg.getAttribute('data-variant')) return Promise.resolve(null);
      return new Promise(function (res) {
        if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
        dlg.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
        var t = dlg.querySelector('[data-up-timer]'), left = dlg.__left == null ? 772 : dlg.__left;
        function tk() { dlg.__left = left; if (t) t.textContent = Math.floor(left / 60) + ':' + ('0' + left % 60).slice(-2); if (left <= 0) { var y = dlg.querySelector('[data-up-yes]'); if (y) y.disabled = true; } }
        tk(); var iv = setInterval(function () { if (left > 0) left--; tk(); }, 1000);
        function done(v, spin) { clearInterval(iv); if (spin) dlg.classList.add('is-busy'); else { dlg.classList.remove('is-open'); document.documentElement.style.overflow = ''; } res(v); }
        dlg.onclick = function (e) {
          if (e.target.closest('[data-up-yes]')) done({ id: +dlg.getAttribute('data-variant'), code: P.upsell.code }, true);
          else if (e.target.closest('[data-up-no]')) done(null, true);
          else if (e.target.closest('[data-up-x]') || e.target === dlg) done(null, false);
        };
      });
    };
    box.__lmbGet = function () {
      var t = P.tiers[sel - 1], map = {}, items = [];
      function add(id, q) { map[id] = (map[id] || 0) + q; }
      if (P.perUnitVariants) {
        for (var k = 0; k < t.qty; k++) {
          var u = units[k], v = C.variants.filter(function (x) { return x.o1 === u[0] && (u.length < 2 || x.o2 === u[1]); })[0];
          if (!v || !v.available) return { error: 'This color / size is sold out (#' + (k + 1) + '). Please pick another one.' };
          add(v.id, 1);
        }
      } else add(C.variantId, t.qty);
      Object.keys(map).forEach(function (id) { items.push({ id: +id, quantity: map[id] }); });
      var gifts = [];
      box.querySelectorAll('[data-lmb-gift]').forEach(function (g) {
        var tiers = (g.getAttribute('data-tiers') || '').split(' ');
        if (tiers.indexOf(String(sel)) >= 0 && g.getAttribute('data-variant')) gifts.push(+g.getAttribute('data-variant'));
      });
      var codes = t.codes.slice();
      Object.keys(P.giftCodes).forEach(function (code) { if (P.giftCodes[code].indexOf(sel) >= 0) codes.push(code); });
      return { items: items, gifts: gifts, codes: codes };
    };
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function openDrawer(res) {
    var d = document.querySelector('cart-drawer');
    if (d && d.renderContents) { d.classList.remove('is-empty'); d.renderContents(res); } else location.href = '/cart';
  }

  /* L'ajout au panier de la fiche est remplacé : tubes/unités + cadeaux, puis codes (fusionnés avec ceux déjà sur le panier), puis tiroir. */
  document.addEventListener('submit', function (e) {
    var box = document.querySelector('.lmb[data-lmb]');
    var form = e.target;
    if (!box || !box.__lmbGet || !form.action || form.action.indexOf('/cart/add') < 0) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = form.querySelector('[type=submit]');
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    var got = box.__lmbGet();
    if (got.error) { alert(got.error); return; }
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (window.LMO_DIRECT) {
      /* checkout direct : panier vidé (comme l'offre de la crème), codes du palier, unités + cadeaux (+ upsell accepté), puis /checkout */
      var all = got.items.concat(got.gifts.map(function (id) { return { id: id, quantity: 1 }; }));
      (box.__lmbUpsell ? box.__lmbUpsell() : Promise.resolve(null)).then(function (up) {
        if (up) { all.push({ id: up.id, quantity: 1 }); got.codes.push(up.code); }
        return post('/cart/clear.js');
      }).then(function () { return post('/cart/update.js', { discount: got.codes.join(',') }); })
        .then(function () { return post('/cart/add.js', { items: all }); })
        .then(function () { location.href = '/checkout'; })
        .catch(function () { form.submit(); });
      return;
    }
    if (window.lmoOpenLoading) window.lmoOpenLoading();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var codes = got.codes.slice(), have = {};
      cart.items.forEach(function (it) {
        have[it.variant_id] = true;
        (it.line_level_discount_allocations || []).forEach(function (a) {
          var t = a.discount_application && a.discount_application.type === 'discount_code' ? a.discount_application.title : null;
          if (t && codes.indexOf(t) < 0) codes.push(t);
        });
      });
      var items = got.items.concat(got.gifts.filter(function (id) { return !have[id]; }).map(function (id) { return { id: id, quantity: 1 }; }));
      return post('/cart/update.js', { discount: codes.join(',') }).then(function () {
        return post('/cart/add.js', { items: items, sections: 'cart-drawer,cart-icon-bubble' });
      });
    }).then(openDrawer).catch(function () { if (window.lmoCloseLoading) window.lmoCloseLoading(); form.submit(); })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }, true);

  function boot() { document.querySelectorAll('.lmb[data-lmb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
